import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { SupportAgentTicket } from "@src/types/support";

export interface PatchTicketPriorityResult {
  success: boolean;
  data?: SupportAgentTicket;
  error?: string;
}

export const patchTicketPriorityUseCase = async (
  ticketId: string,
  newPriority: string,
): Promise<PatchTicketPriorityResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchTicketPriority(
      namespace,
      ticketId,
      newPriority,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update ticket priority")
        .message,
    };
  }
};
